<template>
  <div class="text-ip-color-3 space-y-2" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
    <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-ip-color-10 rounded-md w-fit p-[.38rem]">Our Team</div>
    <div class="text-4xl md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree">Meet Our Experts</div>
  </div>
  <div class="hidden xl:grid grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-8 md:gap-5 lg:gap-6">
    <div @click="selectData(item)" v-for="item in teamData" :key="item.id" class="space-y-3 md:space-y-8" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
      <div class="card-wrapper flip-left">
        <div class="card relative aspect-[295/320]">
          <div class="front items-none hover:shadow-lg rounded-xl md:rounded-3xl overflow-clip transition-shadow duration-300">
            <div class="relative w-full bg-gray-100">
              <figure class="h-full w-full">
                <img class="h-full w-full object-cover" loading="lazy" :src="item.img" alt="" format="webp" quality="80" data-aos="fade" data-aos-easing="ease-out-sine" data-aos-duration="1000" data-aos-delay="200">
              </figure>
            </div>
          </div>
          <div class="back rounded-xl md:rounded-3xl overflow-clip shadow-lg bg-white flex sm:items-center md:items-start w-full h-full">
            <div class="flex-grow p-3 md:py-5 lg:py-5 md:px-5 sm:space-y-6 md:space-y-4">
              <div class="hidden sm:block text-sm sm:text-2xl md:text-[3vw] md:leading-[3.3vw] lg:text-[1.4vw] lg:leading-[2vw] font-semibold figtree text-primary">{{ item.title }}</div>
              <div class="text-3xs sm:text-xs md:text-[2vw] md:leading-[3vw] lg:leading-[1.4vw] lg:text-[.9vw] font-medium figtree text-primary tracking-wide">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="space-y-1 sm:space-y-2 md:space-y-1 text-ip-color-3 pb-4">
        <div class="text-[20px] leading-[24px] md:text-[3vw] md:leading-[3.3vw] lg:text-[1.8vw] lg:leading-[2.2vw] font-bold figtree">{{ item.name }}</div>
        <div class="text-sm leading-[18px] md:text-[2vw] lg:text-[1.1vw] lg:leading-normal font-medium figtree">{{ item.title }}</div>
      </div>
    </div>
  </div>
  <div class="grid xl:hidden grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 md:gap-5 lg:gap-8">
    <div @click="selectData(item)" v-for="item in teamData" :key="item.id" class="space-y-3 md:space-y-8" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
      <div class="relative aspect-[295/320] bg-gray-100 rounded-xl md:rounded-3xl overflow-clip hover:shadow-lg   transition-shadow duration-300">
        <figure class="h-full">
          <img class="h-full w-full object-cover" :src="item.img" loading="lazy" alt="" format="webp" quality="60">
        </figure>
      </div>
      <div class="space-y-1 sm:space-y-2 md:space-y-1 text-ip-color-3 pb-4">
        <div class="word-space text-[20px] leading-[24px] md:text-[2vw] md:leading-[2.4vw] lg:text-[1.8vw] lg:leading-[2.2vw] font-bold figtree">{{ item.name }}</div>
        <div class="text-sm leading-[18px] md:text-[1.1vw] lg:text-[1.1vw] font-medium figtree">{{ item.title }}</div>
      </div>
    </div>
  </div>
  <div class="w-full flex justify-center" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
    <button
      @click="toggleContactModal"
      class="figtree group rounded-3xl h-full py-2 px-3 lg:py-3 lg:px-6 w-fit hover:bg-ip-color-2 bg-ip-color-12 hover:shadow-lg font-semibold text-base md:text-[1.4vw] lg:text-[1.1vw] hover:text-ip-color-3 text-white flex items-center gap-1 transition-colors duration-300">
        Contact Us
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300">
          <path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
        </svg>
    </button>
  </div>
  <transition name="fade"><div v-if="selectedPerson" class="fixed w-full h-full z-10 left-0 top-0 bg-black bg-opacity-25" @click="selectedPerson = null; navbarStore.closeTeamDetail();"></div></transition>
  <transition name="slide-up-2" mode="out-in">
    <div ref="bottomSheet" v-if="selectedPerson" :class="!selectedPerson ? 'translate-y-[100%]':'translate-y-0'" class="transition-all fixed bottom-0 left-0 z-20 flex justify-center w-full max-h-[85%] md:hidden">
      <div class="bg-white p-4 pb-10 rounded-t-lg drop-shadow-lg max-w-[868px] mx-auto max-h-[85%] overflow-auto" data-lenis-prevent v-if="selectedPerson">
        <div class="mb-3 md:hidden">
          <figure class="w-[169px] anime-text mx-auto rounded-xl overflow-hidden">
            <img :src="selectedPerson.img" loading="lazy" alt="" format="webp" quality="80" data-aos="fade" data-aos-easing="ease-out-sine" data-aos-duration="1000" data-aos-delay="200"/>
          </figure>
        </div>
        <div class="flex justify-between gap-6 md:hidden">
          <div class="anime-text font-bold text-center flex justify-center w-full figtree text-[20px] leading-[24px] text-primary">{{ selectedPerson.name }}</div>
          <button @click="selectedPerson = null; navbarStore.closeTeamDetail();" class="absolute top-3 right-3 z-10">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="currentColor"/>
            </svg>
          </button>
        </div>
        <div class="flex gap-6">
          <div class="w-[295px] flex-shrink-0 rounded-xl overflow-hidden hidden md:block">
            <img loading="lazy" class="anime-text" :src="selectedPerson.img" alt="">
          </div>
          <div>
            <button @click="selectedPerson = null; navbarStore.closeTeamDetail();" class="absolute top-6 right-6 hidden md:block z-10">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="currentColor"/>
              </svg>
            </button>
            <div class="anime-text font-bold figtree text-[24px] leading-[28px] text-primary hidden md:block">{{ selectedPerson.name }}</div>
            <div class="anime-text text-center md:text-left figtree text-[18px] leading-[24px] text-primary font-semibold mb-4 md:mb-6" v-if="selectedPerson.title">{{ selectedPerson.title }}</div>
            <div class="anime-text figtree text-[16px] leading-[24px] text-primary">{{ selectedPerson.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <transition name="nested" mode="out-in">
    <div ref="bottomSheet"  v-if="selectedPerson" :class="!selectedPerson ? 'translate-y-[100%]':'!translate-y-0'" class="!mt-0 transition-all fixed !top-0 !left-0 z-30 justify-center items-center w-full h-screen hidden md:flex">
      <div @click="selectedPerson = null; navbarStore.closeTeamDetail();" class="absolute w-full h-full top-0 left-0 bg-black bg-opacity-25 backdrop-blur-sm overlay"></div>
      <div class="relative z-1 w-fit max-w-5xl slide-up-fade">
        <div class="bg-white p-4 pb-10 rounded-t-lg drop-shadow-lg max-w-[868px] mx-auto max-h-[85%] overflow-auto" data-lenis-prevent v-if="selectedPerson">
          <div class="mb-3 md:hidden">
            <figure class="w-[169px] anime-text mx-auto rounded-xl overflow-hidden">
              <img loading="lazy" :src="selectedPerson.img" alt="" format="webp" quality="80" data-aos="fade" data-aos-easing="ease-out-sine" data-aos-duration="1000" data-aos-delay="200"/>
            </figure>
          </div>
          <div class="flex justify-between gap-6 md:hidden">
            <div class="anime-text font-bold text-center flex justify-center w-full figtree text-[20px] leading-[24px] text-primary">{{ selectedPerson.name }}</div>
            <button @click="selectedPerson = null; navbarStore.closeTeamDetail();" class="absolute top-3 right-3 z-10">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <div class="flex gap-6">
            <div class="w-[295px] flex-shrink-0 rounded-xl overflow-hidden hidden md:block">
              <img loading="lazy" class="anime-text" :src="selectedPerson.img" alt="" format="webp" quality="80" />
            </div>
            <div>
              <button @click="selectedPerson = null; navbarStore.closeTeamDetail();" class="absolute top-6 right-6 hidden md:block z-10">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="currentColor"/>
                </svg>
              </button>
              <div class="anime-text font-bold figtree text-[24px] leading-[28px] text-primary hidden md:block">{{ selectedPerson.name }}</div>
              <div class="anime-text text-center md:text-left figtree text-[18px] leading-[24px] text-primary font-semibold mb-4 md:mb-6" v-if="selectedPerson.title">{{ selectedPerson.title }}</div>
              <div class="anime-text figtree text-[16px] leading-[24px] text-primary">{{ selectedPerson.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
const { $anime } = useNuxtApp();
const navbarStore = useNavbarStore();
const bottomSheet = ref(null);
const selectedPerson = ref(null);
const teamData = ref([
  {
    id: 0,
    img: '/images/home/team/lisa.webp',
    name: 'Lisa Imrani',
    title: 'Comm for Development Specialist',
    desc: 'With nearly 20 years of experience in the development sector and strategic communication, I bring a wealth of expertise in creating and implementing sustainable programs tailored to meet the needs of diverse stakeholders.',
  },
  {
    id: 1,
    img: '/images/home/team/nadia.webp',
    name: 'Nadia Andayani',
    title: 'GRI Certified Professional',
    desc: 'With over 20 years in communication and a focus on sustainability, I drive strategic initiatives at ImpacThink. My extensive teaching and training background with global organizations ensures tailored, impactful solutions for our clients.',
  },
  {
    id: 2,
    img: '/images/home/team/lia.webp',
    name: 'Lia Handayani',
    title: 'Creative Comm Specialist',
    desc: 'Experience in creative writing and brand storytelling for intergrated marketing communication for nearly 20 year. I passionately create an impactful sustainable communication program through authentic, relatable and engaging storytelling.',
  },
  {
    id: 3,
    img: '/images/home/team/farida.webp?v=2',
    name: 'Farida Soemawidjaja',
    title: 'Project Management Expert',
    desc: "With over 20 years of professional experience, I've developed a strong background in stakeholder engagement, specializing particularly in Below the Line (BTL) Marketing activities. My expertise extends to managing clients, projects, and businesses, where I've consistently delivered value and experiences through end-to-end project management.",
  },
]);
const to = ref(null);
const selectData = (item) => {
  selectedPerson.value = item;
  navbarStore.openTeamDetail();
  to.value = setTimeout(() => {
    $anime({
      targets: '.anime-text',
      opacity: 1,
      translateY: [20, 0],
      delay: $anime.stagger(50),
      duration: 1000,
      easing: 'easeOutExpo',
    });
  }, 300);
};

const toggleContactModal = () => {
  navbarStore.toggleContact();
};
</script>

<style lang="scss" scoped>
  .slide-up-2-enter-active {
      transition: all 0.3s ease;
  }

  .slide-up-2-enter {
      transition: all 0.3s ease;
  }

  .slide-up-2-leave-active {
      transition: all 0.3s ease;
  }

  .slide-up-2-leave-to, .slide-up-2-enter-from
  /* .slide-up-2-leave-active below version 2.1.8 */ {
      transform: translateY(100%);
      opacity: 0;
  }

  .word-space {
    word-spacing: 100vw;
  }

  .anime-text {
    opacity: 0;
  }

  .card-wrapper {
    perspective: 1000px;

    .card {
      position: relative;
      cursor: pointer;
      transition-duration: 0.6s;
      transition-timing-function: ease-in-out;
      transform-style: preserve-3d;

      .front, .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transform: rotateX(0deg);
      }

      .front {
        z-index: -1;
      }
    }

    //--------------------------------------------------
    // CARD FLIP RIGHT
    //--------------------------------------------------
    &, &.flip-right {
      .card {
        .back {
          transform: rotateY(180deg);
        }
      }

      &:hover {
        .card {
          transform: rotateY(180deg);
        }
      }
    }

    //--------------------------------------------------
    // CARD FLIP LEFT
    //--------------------------------------------------
    &.flip-left {
      .card {
        .back {
          transform: rotateY(-180deg);
        }
      }

      &:hover {
        .card {
          transform: rotateY(-180deg);
        }
      }
    }

    //--------------------------------------------------
    // CARD FLIP UP
    //--------------------------------------------------
    &.flip-up {
      .card {
        .back {
          transform: rotateX(180deg);
        }
      }

      &:hover {
        .card {
          transform: rotateX(180deg);
        }
      }
    }

    //--------------------------------------------------
    // CARD FLIP DOWN
    //--------------------------------------------------
    &.flip-down {
      .card {
        .back {
          transform: rotateX(-180deg);
        }
      }

      &:hover {
        .card {
          transform: rotateX(-180deg);
        }
      }
    }

    //--------------------------------------------------
    // DIAGONAL RIGHT
    //--------------------------------------------------
    &.flip-diagonal-right {
      .card {
        .back {
          transform: rotate3d(1, 1, 0, 180deg);
        }
      }

      &:hover {
        .card {
          transform: rotate3d(1, 1, 0, 180deg);
        }
      }
    }

    //--------------------------------------------------
    // DIAGONAL LEFT
    //--------------------------------------------------
    &.flip-diagonal-left {
      .card {
        .back {
          transform: rotate3d(1, 1, 0, -180deg);
        }
      }

      &:hover {
        .card {
          transform: rotate3d(1, 1, 0, -180deg);
        }
      }
    }

    //--------------------------------------------------
    // INVERTED DIAGONAL RIGHT
    //--------------------------------------------------
    &.flip-inverted-diagonal-right {
      .card {
        .back {
          transform: rotate3d(-1, 1, 0, 180deg);
        }
      }

      &:hover {
        .card {
          transform: rotate3d(-1, 1, 0, 180deg);
        }
      }
    }

    //--------------------------------------------------
    // INVERTED DIAGONAL LEFT
    //--------------------------------------------------
    &.flip-inverted-diagonal-left {
      .card {
        .back {
          transform: rotate3d(1, -1, 0, 180deg);
        }
      }

      &:hover {
        .card {
          transform: rotate3d(1, -1, 0, 180deg);
        }
      }
    }
  }

  .card {
    .front, .back {
      display: flex;
      // align-items: center;
      justify-content: center;
    }
  }
</style>
